/**
 * NavigationStack - A simple service to manage navigation history
 * 
 * This service maintains a stack of navigation entries (pathname + state) to enable dynamic back navigation.
 * Push the current location before navigating forward, and pop when going back.
 */
class NavigationStack {
    constructor() {
        this.stack = [];
    }

    /**
     * Push current location to stack before navigating
     * @param {string} pathname - The current pathname to store
     * @param {object} state - The current location state to store (optional)
     */
    push(pathname, state = null) {
        this.stack.push({ pathname, state });
    }

    /**
     * Get previous location and remove it from stack
     * @returns {{ pathname: string, state: object }|undefined} Previous location or undefined if stack is empty
     */
    pop() {
        return this.stack.pop();
    }

    /**
     * Peek at previous location without removing
     * @returns {{ pathname: string, state: object }|undefined} Previous location or undefined if stack is empty
     */
    peek() {
        return this.stack[this.stack.length - 1];
    }

    /**
     * Clear the entire stack
     */
    clear() {
        this.stack = [];
    }

    /**
     * Get the current stack size
     * @returns {number} Size of the stack
     */
    size() {
        return this.stack.length;
    }
}

export default new NavigationStack();
